import axios from "@/axios";
import axiosDown from "@/axiosDown"; 
import axiosSync from "@/axiosSync";
const API_URL = process.env.VUE_APP_API_BASE_URL;
export function useRtlApi() {
  async function checkUiLogic(id) {
    try {
      const response = await axios.get(API_URL + `/rtl/api/olt/${id}/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getBdcomGponData(id,port) {
    try {
      const response = await axios.get(API_URL + `/rtl/data-get-bdcom-gpon/?id=${id}&int_port=${port}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getBdcomEponData(id,port) {
    try {
      const response = await axiosSync.get(`/bdcom-epon?url_pr=${process.env.VUE_APP_API_BASE_URL}&oltid=${id}&type=onuintfbasicinfo&intfName=${port}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getAviesEponData(id,port) {
    try {
      const response = await axios.get(API_URL + `/rtl/data-get-avies-epon/?oltid=${id}&port_id=${port.split(":")[0]}&onu_id=${port.split(":")[0]}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }

  async function getBdCdataData(id,port) {
    try {
      const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${id}&dta=realtimevlaue&oid=${port}&url=${process.env.VUE_APP_API_BASE_URL}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getEponCloudeData(olt_id,port_number) {
    try {
       const matches = port_number.match(/(GPON|EPON)?\s*(\d+\/\d+\/\d+):(\d+)/i);
    
if (!matches) {
  throw new Error(`Invalid port number format: ${port_number}. Expected format like EPON0/1/1:7 or GPON1/1:1`);
}

const ponid = matches[2];  // This will be "0/1/1"
const onuid = matches[3];  // This will be "7"  
        
        const url = `/cdata-epon-cloude/api?oltid=${olt_id}&dta=onustatus&onu_id=${onuid}&pon_id=${ponid}&url=${process.env.VUE_APP_API_BASE_URL}`;
        
        const response = await axiosSync.get(url);
        
        return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getPPPOE(pppoe_id) {
    try {
      const response = await axios.get(API_URL + `/api/pppoe-id/?pppoe_id=${pppoe_id}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function downCount(pppoe_id) {
    try {
      const response = await axiosDown.get(`/api/session-log/${JSON.parse(localStorage.getItem("user_data")).fendy_user_id}/?pppoe_id=${pppoe_id}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getMultiplePPPOE(id) {
    let userPromise = new Promise((resolve, reject) => {
      let user= JSON.parse(localStorage.getItem("user_data"));
      if (user) {
        resolve(user);
      } else {
        reject("User not found in localStorage");
      }
    });
    try {
      const user = await userPromise;
      const response = await axios.get(API_URL + `/api/get-port-data-list/${id}/`, {
        headers: {
          'X-Custom-Header': user.id
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting data:", error);
      throw error;
    }
  }
 
  
  return {
    checkUiLogic,
    getBdcomGponData,
    getBdcomEponData,
    getAviesEponData,
    getBdCdataData,
    getEponCloudeData,
    getMultiplePPPOE,
    getPPPOE,
    downCount
  };
}